import { useEffect } from 'react';

import { Callable } from '@vimeo/core/types/generic';

import { registerInterval, unRegisterInterval } from '../../utils/general/timers';

/**
 * Use specific interval and call method with a fixed time.
 */
export function useInterval(
  isStarted: boolean,
  callable: Callable,
  config: { period?: number; checkCallable?: boolean; initialize?: boolean } = {
    period: 1000,
    checkCallable: false,
    initialize: false,
  },
): void {
  useEffect(() => {
    if (isStarted) {
      // Call interval CB first time if required.
      if (config.initialize) {
        callable();
      }

      const interval: number = registerInterval(callable, config.period, 'useInterval');

      return () => unRegisterInterval(interval);
    }
  }, [isStarted, config.checkCallable ? callable : 0, config.period]);
}
